// use style component to wrap a div with bottom margin
import { styled } from '@mui/material/styles';

const DateSelectorContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(5),
}));

export default DateSelectorContainer;
